export const environment = {
  production: false,
  base_url: 'https://txwrpe80ld.execute-api.cn-north-1.amazonaws.com.cn/prod',
  base_url_second: 'https://vmxakok2h4.execute-api.cn-north-1.amazonaws.com.cn/dev',
  leopoly_login: 'https://wikyinsole.leopoly.com/insole/api',
  login_url: 'https://wikyinsole.leopoly.com/login.html',
  afo_login_url: 'https://edserafo.leopoly.com/login.html',
  spinal_brace_login_url: 'https://edserspinal.leopoly.com/login.html',
  spinal_brace_sign_in_url: 'https://edserspinal.leopoly.com/insole/api',
  sensingtex_url: 'https://sensinghealth.ddns.net/api',
  stripe_api_key: 'pk_test_51K7M8GCHsN70jOILMVGXr37YcXJwoYHxkbuc3XGqsJmtxsVLVPDUodEExymoRdnpXGgaKq8TAZgOxGQhOfHSYXix00AuCDdJcP',
  ws_url: 'wss://s80ifo31vj.execute-api.cn-north-1.amazonaws.com.cn/prod/',
  filesEncryptPassword: '\K^$8P)]A(pE>s=V',
  stripeSubscriptions: {
    client: {
      old: 'prod_Qv62OeLENyQwLo',
      basic: 'prod_Qv62OeLENyQwLo',
      advanced: 'prod_Qv68mQyAuQrggh',
      pro: 'prod_Qv6APp9xlnK2V1',
      three_d_design_insoles: 'prod_Qv6DBdWxgfDrfp',
      three_d_design_afo: 'prod_QrJfdE764go4kc',
      three_d_design_spinal_brace: 'prod_QrJkQvkDfUfJZw'
    },
    distributor: {
      old: 'prod_Qv62OeLENyQwLo',
      basic: 'prod_Qv62OeLENyQwLo',
      advanced: 'prod_Qv68mQyAuQrggh',
      pro: 'prod_Qv6APp9xlnK2V1',
      three_d_design_insoles: 'prod_Qv6DBdWxgfDrfp',
      three_d_design_afo: 'prod_QrJfdE764go4kc',
      three_d_design_spinal_brace: 'prod_QrJkQvkDfUfJZw'
    }

  },
  firebaseOld: {
    apiKey: "AIzaSyAwa6NjJjdddmN8e9nHsWe1E0cVSGaDadY",
    authDomain: "wikyscan.firebaseapp.com",
    projectId: "wikyscan",
    storageBucket: "wikyscan.appspot.com",
    messagingSenderId: "1047107268143",
    appId: "1:1047107268143:web:3242c9bbd7830c723d20da",
    measurementId: "G-EVT28ZNZ5Y"
  },
  firebase: {
    apiKey: "AIzaSyAOu1tGXYaGT8jbGW3vGUqHW-GyOdbXKlY",
    authDomain: "fore2feet.firebaseapp.com",
    projectId: "fore2feet",
    storageBucket: "fore2feet.appspot.com",
    messagingSenderId: "590501556881",
    appId: "1:590501556881:web:ee8c6ee45acbf72be4c530",
    measurementId: "G-3KQC1SLQ83"
  },
  firebaseUser: "sebasbeje@gmail.com",
  firebasePass: "cabron1969",
  cognito: {
    userPoolId: 'eu-west-1_cKHpZhhOG',
    userPoolWebClientId: '5rai3ef6cl3sun86bp9pafaki9',
  },
  leopoly: {
    username: "wiky_embedded_insole",
    password: "Leoleo837$",
    leoShape: {
      username: "wiky_embedded_afo",
      password: "Leoleo837$"
    },
    spinalBrace: {
      username: "wiky_embedded_spinal",
      password: "Leoleo837$"
    },
    three_d_preview_viewer: {
      base_url: "https://staging.viewer.medairum.leoinsole.leopoly.com/login.html",
      login_url: "https://staging.viewer.medairum.leoinsole.leopoly.com/insole/api/sign-in",
      username: "wiky_embedded_viewer",
      password: "Leoleo113",
    }
  },
  adobeClientId: "57957984dde4468e83e4a8b4aa72c263",
  pdfservices_url: "https://pdf-services-ue1.adobe.io",
  pdfservices_clientId: "0404689d953a4afc92035bee0c4dfc35",
  pdfservices_clientSecret: "p8e-8mU91RAJ-NTPS_UN8sRKiDB04Mi-2oah",
  cognitoTest: {
    userPoolId: "eu-west-1_6Eu9neTcW",
    userPoolClientId: "3ihdqpoar9m40nh2ru5lj6h89r"
  },
  authingAppId: '69425fd6c28e0d08ed9382c1',
  authingAppSecret: '6b7c8cb270869d3fd17d2ed339dc6de7',
  authingAppHost: 'https://qkbg9rwyiwc3-demo.authing.cn',
  volumental: {
    clientId: 'TCAvYHX3ZCNzscJepRPF6wcBQH9Au2j9',
    clientSecret: 'limtC4ecirmQQijoccoC1HkUm28GViKH9DB9YL3CXixJsJHRTTrZYfZ38KHJm30B',
    widgetUrl: 'https://widget.volumental.com',
    authUrl: 'https://login.volumental.com/oauth/token'
  },
  roboflow: {
    apiKey: "WWZS9p5DXIkdQzqouIXX"
  }
};